import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Workplace from '../images/workplace.svg';
import EmailIcon from '@mui/icons-material/Email';
import ChatIcon from '@mui/icons-material/Chat';
import LocationOnIcon from '@mui/icons-material/LocationOn'
import "../styles/contacts.css"


const Contacts = () => {
   const iconStyles = {
    width: "30px",
    height: "30px",
    color: "#1e3a8a "
   };

    return (
        <div>
            <Navbar />
            <div className='container  w-min-full p-4 mx-auto'>
                <div className='bg-slate-50 h-[400px] '>
                    <h1 className='mt-24 text-xl text-blue-900 md:ml-[80px] '>Contact us</h1>
                    <h2 className='mt-1 text-[48px] font-semibold md:ml-[80px] '>Get in touch</h2>
                    <p className='text-[18px] text-gray-500 md:ml-[80px] '>Our friendly team would love to hear from you</p>
                    <img className='absolute w-[90%] md:w-[1100px] top-[480px]  left-5' src={Workplace} alt="workplace" />
                </div>
                <div className='container mx-auto flex flex-col md:flex-row md:justify-between  md:mt-[600px]  mt-5 w-min-full md:w-[1000px]'>

                    <div className='mr-[50px] mt-[50px] flex flex-col justify-between min-h-[60vh] md:w-[600px] border-4 rounded-md p-4  border-yellow-400 min-w-full'>
                        <article className='flex flex-row md:justify-normal items-start'>
                            <div className='md:mr-5 '>
                               <ChatIcon style={iconStyles} className='text-blue-600' />
                            </div>
                            <div className=' flex flex-col ml-[40px]   w-[250px]'>
                                <h3 className='text-[22px] text-blue-900'>Phone and Email</h3>
                                <p className='text-[18px]    pr-[50px] h-[60px]'>stephmenssupertech<br />@gmail.com</p>
                                <p className='text-[18px] '>059 894 6885</p>
                                <p className='text-[22px] text-blue-900 '>WhatsApp Only</p>
                                <p className='text-[18px] '>059 894 6885</p>
                            </div>
                        </article>
                        <article className='flex flex-row  md:justify-normal items-start'>
                            <div className='md:mr-5'>
                                <EmailIcon style={iconStyles} className='text-blue-900' />
                            </div>
                            <div className='flex flex-col ml-[40px]'>
                                <h3 className='text-[22px] text-blue-900 '>Stephmens Super Tech</h3>
                                <p className='text-[18px] '>PO Box BT 39, <br />Techiman, Bono East</p>
                            </div>
                        </article>
                        <article className='flex flex-row justify-between items-start md:justify-normal'>
                            <div className='md:mr-5'>
                                <LocationOnIcon style={iconStyles} className='text-blue-900' />
                            </div>
                            <div className='flex flex-col ml-[40px]'>
                                <h3 className='text-[22px] text-blue-900 '>Office Address</h3>
                                <p className='text-[18px]'>Stephmens Building, BT-0057-1832, 4 GUAVA LN, TAKOFIANO</p>
                            </div>
                        </article>
                    </div>
                    <div className='container mx-auto my-20  p-2 '>
                        <h2 className='text-[30px] font-semibold'>How can we help you?</h2>
                        <p className='text-gray-500 text-[18px]'>We look forward to your message</p>
                        <form method='POST' className='container flex flex-col justify-between  h-[100vh]'>
                            <div className=' flex flex-col justify-center'>
                                <label className='mb-3' htmlFor="name">Name *</label>
                                <input className='p-2 rounded-md border-2 border-gray-700 ' type='text' name="user-name" id="name" placeholder='Your name' required />
                            </div>
                            <div className='flex flex-col justify-center'>
                                <label className="mb-3" htmlFor="email">Email *</label>
                                <input className='p-2 rounded-md border-2 border-gray-700 w-full' type='email' name="user-email" id="email" placeholder='name@mail.com' required />
                            </div>
                            <div>
                                <label className='mb-3' htmlFor="tel">Phone number *</label>
                                <input className='p-2 rounded-md border-2 border-gray-700 w-full' type='tel' name="user-phone" id="tel" required />
                            </div>

                            <p className='mt-3'>Purpose of contact *</p>
                            <div className='flex flex-col justify-between p-2'>

                                <div>
                                    <input type="radio" name="purpose" id="services-request" checked />
                                    <label htmlFor="services-request" className='p-3'>Product/services request</label>
                                </div>
                                <div>
                                    <input type="radio" name="purpose" id="services-review" />
                                    <label htmlFor="services-request" className='p-3'>Product/services review</label>
                                </div>
                                <div>
                                    <input type="radio" name="purpose" id="general-inquiry" />
                                    <label htmlFor="services-request" className='p-3'>Product/services review</label>
                                </div>
                            </div>
                            <div>
                                <p>How can we help? *</p>
                                <textarea className='w-full h-[200px] border-2 border-gray-500 mt-3 rounded-md mb-5' name="help-message" id="help-message"></textarea>
                            </div>
                            <input type='button' value="Send message" className='bg-blue-900 text-white p-3 rounded-md' />
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Contacts;